/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1508
 */

"use strict"

var /* [auto-meaningful-name] */require_2599_$_2599_index$CopyToClipboard = require(/* 2599 */"./2599/index").CopyToClipboard
require_2599_$_2599_index$CopyToClipboard.CopyToClipboard = require_2599_$_2599_index$CopyToClipboard
module.exports = require_2599_$_2599_index$CopyToClipboard
